import React from 'react'

const Setting = () => {
  return (
    <div>Setting Page</div>
  )
}

export default Setting;